<template>
  <!-- <div class="col-xl-4"> -->
  <div>
    <div class="portlet">
      <div class="portlet-head">
        <h3><i class="fas fa-boxes mr-2"></i>Materiały z magazynu</h3>
      </div>
      <div class="portlet-body">
        <b-table
          id="warehouseevents-table"
          class="table table-list table-mobile m-0"
          ref="warehouseEvents_table"
          :fields="fields"
          :items="warehouseEvents"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          stacked="lg"
          show-empty
          empty-text="Brak wydanych materiałów"
          @row-clicked="expandAdditionalInfo"
        >
          <template v-slot:empty="{ emptyText }">
            <div class="empty">
              <i class="empty-state fas fa-file-signature"></i>
              <span class="empty-search">{{ emptyText }}</span>
            </div>
          </template>
          <template v-slot:cell(issue_date)="data">
            {{ data.item.issue_date | date }}
            <br />
            <b-badge :variant="badgeType((badgeColor = data.item.type))">{{
              types[data.item.type]
            }}</b-badge>
          </template>
          <template v-slot:cell(cost)="data">{{
            formatNumber(data.item.cost)
          }}</template>
        </b-table>
      </div>
    </div>
    <ModalMaterialsEvent :event="selectedEvent" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { zfill } from "@/services/helpers";
import ModalMaterialsEvent from "@/components/warehouse/ModalMaterialsEvent";
import {formatDateTime} from "@/services/helpers";

export default {
  name: "WarehouseConstructionPortlet",
  props: {
    warehouseEvents: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ModalMaterialsEvent,
  },
  computed: {
    ...mapGetters("company", ["getMainBaseCurrency"]),
    ...mapGetters("issuances", ["types"]),
    ...mapGetters("user", ["getRole"]),
  },
  data() {
    return {
      selectedEvent: {},
      selected: {},
      sortBy: "issue_date",
      sortDesc: true,
      fields: [
        { key: "issue_date", label: "Zdarzenie", sortable: true },
        { key: "quantity", label: "Ilość", class: "text-right" },
        // { key: "cost", label: "Wartość", class: "text-right" },
      ],
    };
  },
  created() {
    if(this.getRole !== 'subcontractor') {
      this.fields.push(
        { key: "cost", label: "Wartość", class: "text-right" },
      )
    }
  },
  filters: {
    date(value) {
      return formatDateTime(value, "YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    expandAdditionalInfo(row) {
      this.selectedEvent = row;
      this.$nextTick(() => {
        this.$bvModal.show("materialevent-modal");
      });
    },
    badgeType() {
      if (this.badgeColor == "wz") {
        return "primary";
      } else if (this.badgeColor == "pmb") {
        return "success";
      } else {
        return "info";
      }
    },
    formatNumber: function (cost) {
      if (cost) {
        return zfill(cost) + " " + this.getMainBaseCurrency;
      } else {
        return 0.0 + this.getMainBaseCurrency;
      }
    },
  },
};
</script>
